import React from 'react';
import { useFormContext } from 'react-hook-form';
import { emptyRolesValidation } from '../../../utils/validations';
import CheckBox from './CheckBox';

const RoleInput = ({ roles, loading }) => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div className="flex flex-col gap-2">
      {roles.map((role) => (
        <CheckBox
          value={role.id}
          name={'roles'}
          disabled={loading}
          label={role.displayName}
          validation={emptyRolesValidation}
        />
      ))}
      <span className="text-xs text-contrast1 mt-1">{errors['roles']?.message}</span>
    </div>
  );
};

export default RoleInput;
